import { IRawStore, IStore } from './types';

export const convertActionPageLCP = ({ data }: IRawStore): IStore => {
  return {
    data: {
      content: {
        ...data.content,
      },
      provider: { ...data.provider.action },
    },
  };
};
